import {Setting} from "../../../setting/Setting";
import {DraftElement, DraftElementItem} from "../../../../../../../feature/Draft";
import {combineSettingDescription} from "../list/SettingList";
import {
    assistantAsking, assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";


export const generateLoreItemsPrompt = (vars: {
    category: Setting,
    genres: string[],
    synopsis: string,
    setting?: string,
    element: DraftElement,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием лора для литературного произведения. Нужно подробно описать элемент лора."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши элемент сеттинга", vars.element.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй описание элемента сеттинга",
        "Проанализируй контекст",
        "Сгенерируй элементы лора на основе элемента сеттинга",
        "Придумай названия объектам",
    ]))
    .concat(assistantAskingForRequirements([
        "Элементы лора должны быть подробным",
        "Элементы лора должны быть уникальными и соответствовать жанру",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": [{"id":number, "title":string, "description":string}]}'))
    .concat(assistantAskingForExample({
        data: [
            {
                id: 1,
                title: "Флора",
                description: "Гигантские деревья и цветы"
            },
            {
                id: 2,
                title: "Фауна",
                description: "В основном мелкие животные"
            },
            {
                id: 3,
                title: "Погода",
                description: "Вечный дождь"
            },
            {
                id: 4,
                title: "Циклы",
                description: "День длится 3 часа, ночь 3 часа"
            }
        ]
    }))
    .concat(assistantAskingForAction(`Придумай элементы лора на основе элемента сеттинга.
${vars.category.prompt.lore.list}`))

export const generateLoreItemPrompt = (vars: {
    category?: Setting,
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    element: DraftElement,
    setting?: string,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно придумать элемент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши категорию сеттинга", vars.category ? combineSettingDescription(vars.category) : undefined))
    .concat(assistantAsking("Опиши элемент сеттинга", vars.element.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй описание элемента сеттинга",
        "Проанализируй описание элемента сеттинга",
        "Проанализируй контекст",
        "Сгенерируй один элемент лора на основе элемента сеттинга",
        "Придумай названия объектам",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Элемент лора должен быть подробным",
        "Элемент лора должен быть уникальным и соответствовать жанру",
        "Элемент лора не должен повторяться с другими элементами",
        "При возможности используй все пять чувств для создания более живого описания элемента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно придумать элемент лора. ${vars.customPrompt ? ('\n\n' + vars.customPrompt) : ''}`))


export const improveLoreItemPrompt = (vars: {
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    setting?: string,
    element: DraftElement,
    item: DraftElementItem,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно подробно описать элемент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши элемент сеттинга", vars.element.description))
    .concat(assistantAsking("Опиши элемент лора", vars.item.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй элемент сеттинга",
        "Проанализируй контекст",
        "Наполни элемент лора деталями",
        "Придумай названия объектам",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Элемент лора должен быть подробным",
        "Элемент лора быть уникальным и соответствовать жанру",
        "Элемент лора не должен повторяться с другими элементами",
        "При возможности используй все пять чувств для создания более живого описания элемента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно доработать и улучшить элемент лора: ${JSON.stringify({
        title: vars.item.title,
        description: vars.item.description
    })}.${vars.customPrompt ? ('\n\n' + vars.customPrompt) : ''}`))

